import {
    ArrowPathIcon,
    CalendarDaysIcon,
    ClockIcon,
    InformationCircleIcon,
} from '@heroicons/react/24/outline';
import { PersonSummary } from '../../../components/avatar';
import { formatDateTime } from '../../../common/formatDateText';
import { CourseFormGrid, CourseFormSection } from '../components/CourseFormSection';

const SECTION_ICON_CLASS = 'h-5 w-5';

/**
 * @param {object} props
 * @param {import('@heroicons/react/24/outline').ForwardRefExoticComponent} props.icon
 * @param {string} props.label
 * @param {import('react').ReactNode} props.value
 */
const InfoTile = ({ icon: Icon, label, value }) => (
    <div className="task-detail__info-tile">
        <span className="task-detail__info-tile-icon" aria-hidden="true">
            <Icon />
        </span>
        <div className="task-detail__info-tile-body">
            <span className="task-detail__info-label">{label}</span>
            <span className="task-detail__info-value">{value}</span>
        </div>
    </div>
);

export const TaskDetailInfo = ({ detail, isTeacher }) => (
    <CourseFormSection
        id="task-detail-info"
        title="Información"
        description="Equipo, fechas y registro de la tarea."
        icon={<InformationCircleIcon className={SECTION_ICON_CLASS} />}
    >
        <div className="task-detail__info-group">
            <PersonSummary
                variant="card"
                firstName={detail.teacherId?.firstName}
                lastName={detail.teacherId?.lastName}
                role="Profesor"
                className="task-detail__info-person"
            />
        </div>

        <div className="task-detail__info-group">
            <InfoTile
                icon={CalendarDaysIcon}
                label="Fecha límite"
                value={formatDateTime(detail.dueDate)}
            />
        </div>

        {isTeacher ? (
            <div className="task-detail__info-group task-detail__info-group--muted">
                <CourseFormGrid className="task-detail__info-tiles--compact">
                    <InfoTile
                        icon={ClockIcon}
                        label="Creada"
                        value={formatDateTime(detail.createdAt)}
                    />
                    <InfoTile
                        icon={ArrowPathIcon}
                        label="Actualizada"
                        value={formatDateTime(detail.updatedAt)}
                    />
                </CourseFormGrid>
            </div>
        ) : null}
    </CourseFormSection>
);
